module.exports = __webpack_public_path__ + "static/img/left_icon.e46d6a5a.svg";